import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import jQuery from "jquery";
const $ = jQuery;

export class ZIDXAccountMediaLibrary implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountMediaLibraryContainer";
    }
    render() {
        // console.log("media library");
        let self = this;
        let url = new URL(window.location.href);
        let parentId = url.searchParams.get("virtual_folder_parent_id");
        let virtual_folder_parent_id = 0;
        if (parentId) {
            virtual_folder_parent_id = parseInt(parentId, 10) || 0;
        }

        $(".zidxAccountMediaLibraryContainer .zidxAddFolderButton", this.zidx.peakidxShadowRoot).on("click", function (this: Element, e: JQuery.Event) {
            self.addFolder(virtual_folder_parent_id);
        });
        $(".zidxAccountMediaLibraryContainer .zidxAddFileButton", this.zidx.peakidxShadowRoot).on("click", function (this: Element, e: JQuery.Event) {
            self.addFile(virtual_folder_parent_id);
        });
    }
    addFolder(virtual_folder_parent_id:number){
        let self=this;
        let modalContent1='<div style="background-color:var(--background-color); color:var(--text-color); border:1px solid var(--border-color); width:100%; float:left; padding:10px; border-radius:var(--button-border-radius)">' +
            '<h2>New Folder</h2>' +
            '<div id="zidxformStatusMessagezidxFormAddFolder" class="zidxFloat"></div>' +
            '<form id="zidxFormAddFolder" action="/account/media-library/folder/save" method="post" class="zidxForm" enctype="multipart/form-data">' +
            '<input type="hidden" name="fileUploadingField" autocomplete="off" id="fileUploadingFieldzidxFormAddFolder" value="0">' +
            '<input type="hidden" name="virtual_folder_parent_id" id="virtual_folder_parent_id" value="'+virtual_folder_parent_id+'">' +
            '<div id="virtual_folder_name_container" class="zidxFloat">' +
            '<div class="zidxLabel"><label for="virtual_folder_name">Folder Name</label> </div>' +
            '<div class="zidxField"><input type="text" name="virtual_folder_name" id="virtual_folder_name" placeholder="" required="required" value="" class="zidxDefaultInput zidxCloudFileUploadField"></div>' +
            '</div>' +
            '<div class="zidxFloat"><div class="zidxField">' +
            '<button type="submit" name="submit1">Save</button> ' +
            '<button type="button" name="cancel1" onclick="window.location.href=\'/account/media-library\';">Cancel</button></div></div></form></div>';
        let width=500;
        let height=300;
        // @ts-ignore
        self.zidx.modalWindow.showModal(modalContent1,{
            'width':width,
            'height':height,
            "maxWidth":width,
            "maxHeight":height,
            "padding":0,
            "disableClose":false,
            "fullscreen":false
        });
    }
    addFile(virtual_folder_parent_id:number){
        let self=this;
        let modalContent1='<div style="background-color:var(--background-color); color:var(--text-color); border:1px solid var(--border-color); width:100%; float:left; padding:10px; border-radius:var(--button-border-radius)">' +
            '<h2>Upload File</h2>' +
            '<div id="zidxformStatusMessagezidxFormAddFile" class="zidxFloat"></div><form id="zidxFormAddFile" action="/account/media-library/file/save" method="post" class="zidxForm" enctype="multipart/form-data">' +
            '<input type="hidden" name="fileUploadingField" autocomplete="off" id="fileUploadingFieldzidxFormAddFile" value="0">' +
            '<input type="hidden" name="virtual_folder_parent_id" id="virtual_folder_parent_id" value="'+virtual_folder_parent_id+'">' +
            '<div id="cloud_file_id_container" class="zidxFloat">' +
            '<div class="zidxLabel"><label for="cloud_file_id">File</label> </div>' +
            '<div class="zidxField"><div id="cloud_file_id_preview" class="zidxFloat"></div>' +
            '<input type="hidden" name="cloud_file_id_filefieldtype" id="cloud_file_id_filefieldtype" value="1">' +
            '<input type="hidden" name="cloud_file_id_usertable" id="cloud_file_id_usertable" value="0">' +
            '<input type="hidden" name="cloud_file_id_url" id="cloud_file_id_url" value="">' +
            '<input type="hidden" name="cloud_file_id" id="cloud_file_id" class="zidxCloudFileField" required="required" value="">' +
            '<input type="file" name="cloud_file_id_file" id="cloud_file_id_file" placeholder="" value="" class="zidxDefaultInput zidxCloudFileUploadField">' +
            '<progress id="cloud_file_id_progress" style="display:none;"></progress>' +
            '</div>' +
            '</div>' +
            '<div class="zidxFloat">' +
            '<div class="zidxField"><button type="submit" name="submit1">Save</button> ' +
            '<button type="button" name="cancel1" onclick="window.location.href=\'/account/media-library\';">Cancel</button></div></div></form></div>';
        let width=500;
        let height=300;
        // @ts-ignore
        self.zidx.modalWindow.showModal(modalContent1,{
            'width':width,
            'height':height,
            "maxWidth":width,
            "maxHeight":height,
            "padding":0,
            "disableClose":false,
            "fullscreen":false
        });
    }
}
